import _defineProperty from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import { cloneElement } from 'react';
import { isElement } from '@mantine/utils';
import { useFocusTrap, useMergedRef } from '@mantine/hooks';

function FocusTrap(_ref) {
  var children = _ref.children,
      _ref$active = _ref.active,
      active = _ref$active === void 0 ? true : _ref$active,
      _ref$refProp = _ref.refProp,
      refProp = _ref$refProp === void 0 ? "ref" : _ref$refProp;
  var focusTrapRef = useFocusTrap(active);
  var ref = useMergedRef(focusTrapRef, children == null ? void 0 : children.ref);

  if (!isElement(children)) {
    return children;
  }

  return cloneElement(children, _defineProperty({}, refProp, ref));
}

FocusTrap.displayName = "@mantine/core/FocusTrap";
export { FocusTrap };